import { CContainer } from "@coreui/react-pro";
import React from "react";
import { Outlet } from "react-router-dom";
import {
  AppAside,
  AppSidebar,
  AppFooter,
  AppHeader,
} from "../components/index";

const DefaultLayout = () => {
  return (
    <>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <div className="px-md-6 px-sm-1">
            <Outlet />
          </div>
        </div>
        <AppFooter />
      </div>
      <AppAside />
    </>
  );
};

export default DefaultLayout;
//px-md-5 px-sm-1
